import { Tag } from '@blueprintjs/core';
import { AceCardSection } from '../AceCard';
import { useApplicationDetail } from '@axo/shared/data-access/hooks';
import { ReactNode } from 'react';

interface KreditStatusConsentProps {
  applicationID: string;
}

export const KreditStatusConsent: React.FC<KreditStatusConsentProps> = ({
  applicationID,
}) => {
  const { data: applicationData } = useApplicationDetail(applicationID);

  let tag: ReactNode;
  switch (applicationData?.CreditStatusConsent) {
    case true:
      tag = (
        <Tag minimal round intent="success">
          YES
        </Tag>
      );
      break;
    default:
      tag = (
        <Tag minimal round intent="danger">
          NO
        </Tag>
      );
      break;
  }

  return (
    <AceCardSection
      id={`KreditStatusConsent.${applicationID}`}
      title="KreditStatus Consent"
      tag={tag}
    >
      {applicationData?.CreditStatusConsent
        ? 'The user has given consent'
        : 'The user has not given consent'}
    </AceCardSection>
  );
};
